export * from './lib/faqs/faqs.component';
